import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const PayBill00Table: GenericTableSchemaInterface = {
  id: 'paybill-00',
  name: 'Pay Bill Funnel 00',
  description: 'This table contains data regarding how many people we navigate to online bill pay.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'Pay Bill Start'
    },
    c04: {
      name: 'Pay by Phone'
    },
    c05: {
      name: 'Pay Online'
    },
    c06: {
      name: 'Navigate to Login'
    },
    c07: {
      name: 'Navigate to Online Bill Pay Page'
    }
  }
}
